import Button from '@codegouvfr/react-dsfr/Button';
import React from 'react';

export const FcChip = ({ value, onRemove }: FcChipProps) => {
  return (
    <div className={'flex items-center gap-2 rounded-full'}
         style={{ backgroundColor: '#ececfd', padding: '2px 4px 4px 12px' }}>

      <span className={'color-primary'}>{value}</span>

      <Button
        iconId="fr-icon-close-line"
        size="small"
        onClick={(ev) => {
          ev.stopPropagation();
          onRemove(value);
        }}
        priority="tertiary no outline"
        title="Supprimer"
      />
    </div>
  );
};

interface FcChipProps {
  value: string;
  onRemove: (value: string) => void;
}